import React from "react";
import { Link } from "react-router-dom";
import { heroHighlights } from "../data/siteContent";

function HeroSection() {
  return (
    <section id="hero" className="hero section dark-background">
      <div className="container">
        <div className="row gy-4 align-items-center">
          <div
            className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center"
            data-aos="zoom-out"
          >
            <span className="hero-eyebrow">Software for growing businesses and bold ideas</span>
            <h1>
              Operating Software builds digital products that move real
              businesses forward.
            </h1>
            <p>
              We focus on practical software, strong collaboration, and
              products shaped around everyday operational needs.
            </p>

            <ul className="hero-highlights">
              {heroHighlights.map((item) => (
                <li key={item}>
                  <i className="bi bi-check-circle-fill"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <div className="d-flex hero-actions">
              <a href="#services" className="btn-get-started">
                Explore Our Work
              </a>
              <Link to="/services" className="btn-watch-video d-flex align-items-center">
                <i className="bi bi-briefcase"></i>
                <span>View Services</span>
              </Link>
              <a href="#contact" className="btn-watch-video d-flex align-items-center">
                <i className="bi bi-chat-dots"></i>
                <span>Start a Project</span>
              </a>
            </div>
          </div>

          <div
            className="col-lg-6 order-1 order-lg-2 hero-img"
            data-aos="zoom-out"
            data-aos-delay="200"
          >
            <img
              src="assets/img/hero-img.png"
              className="img-fluid animated"
              alt="Illustration representing Operating Software services"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
